enum AuthProvider {
	LOCAL = 'LOCAL',
	GOOGLE = 'GOOGLE',
	FACEBOOK = 'FACEBOOK',
	MICROSOFT = 'MICROSOFT',
	WEBHOTELIER = 'WEBHOTELIER',
	REVHERO = 'REVHERO'
}

export default AuthProvider;